// @ts-nocheck
import { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const signInAccountTitle: TypographyProps = {
    variant: "h4",
    as: "h2",
    css: css`
        padding-bottom: ${pxToRem(15)};
        width: 100%;
    `,
};
